import React from 'react';
import { Link } from 'react-router-dom';

const ThankYouPage = () => {
  return (
    <div className="min-h-screen bg-primary-black text-primary-white flex flex-col">
      <header className="py-6 bg-primary-black">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center">
            <h1 className="text-2xl font-bold">Kelton Oliveira</h1>
            <p className="text-sm text-gray-300">TERAPEUTA | PALESTRANTE | AUTOR</p>
          </div>
        </div>
      </header>
      
      <main className="flex-grow flex items-center">
        <div className="container mx-auto px-4 py-16">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-8">
              Obrigado por dar este primeiro passo na sua jornada emocional.
            </h1>
            
            <p className="text-xl mb-8">
              Você acaba de dar um passo importante rumo à liberdade emocional.
              <br /><br />
              Nos próximos minutos você receberá um e-mail com as orientações para o seu agendamento (ou para acessar nossa comunidade, se foi o seu caso).
            </p>
            
            <p className="text-xl mb-12">
              Enquanto isso, aproveite para acompanhar meu canal no YouTube e meus conteúdos exclusivos, onde compartilho reflexões e ferramentas para aprofundar sua jornada.
              <br /><br />
              Lembre-se: Proclamar liberdade às mentes cativas é um caminho contínuo — e estou aqui para te guiar.
            </p>
            
            <div className="flex flex-col md:flex-row gap-6 justify-center">
              <a 
                href="https://youtube.com/@keltonpsi" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="btn btn-secondary text-lg px-8 py-4"
              >
                Canal no YouTube → Acompanhar Conteúdo
              </a>
              
              <Link 
                to="/" 
                className="btn btn-outline text-lg px-8 py-4"
              >
                Voltar para o Site → Explorar mais
              </Link>
            </div>
          </div>
        </div>
      </main>
      
      <footer className="py-8 bg-dark-gray">
        <div className="container mx-auto px-4 text-center">
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} Kelton Oliveira. Todos os direitos reservados.
            <br />
            Terapeuta | Palestrante | Autor
            <br />
            Proclamo liberdade às mentes cativas.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default ThankYouPage;
